"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppointmentCancelWidget;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _AppointmentCancelContainer = _interopRequireDefault(require("./components/AppointmentCancelContainer"));
var _getInitialContext = _interopRequireDefault(require("./stateMachine/getInitialContext"));
var _main = require("./stateMachine/machines/main");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getDevLogger = () => {
  if (process.env.NODE_ENV !== 'development') {
    return () => {};
  }
  return state => {
    /*eslint-disable no-console */
    if (console && console.groupCollapsed && console.log && console.groupEnd) {
      console.group(`[MachineTransition]: `);
      console.log(state.value, {
        ...state
      });
      console.groupEnd();
    }
    /*eslint-enable no-console */
  };
};
function AppointmentCancelWidget(_ref) {
  let {
    appointment,
    appointmentId,
    createRescheduleLink,
    track,
    searchProvidersLink,
    services
  } = _ref;
  const machine = (0, _react.useRef)((0, _main.createAppointmentCancelMachine)({
    ...(0, _getInitialContext.default)(),
    appointment,
    appointmentId,
    services
  }));
  return /*#__PURE__*/_react.default.createElement(_AppointmentCancelContainer.default, {
    createRescheduleLink: createRescheduleLink,
    logState: getDevLogger(),
    machine: machine.current,
    track: track,
    searchProvidersLink: searchProvidersLink
  });
}
AppointmentCancelWidget.propTypes = {
  /**
   * An object representing the appointment we wish to cancel
   * Either this or the appointmentId string are required for this widget to initialize properly.
   * If both are provided, will default to using appointment object
   */
  appointment: (0, _propTypes.shape)({
    appointment_ehr_id: _propTypes.string.isRequired,
    start_datetime: _propTypes.string.isRequired,
    patient_relationship: _propTypes.string.isRequired,
    status: _propTypes.string.isRequired,
    purpose_name: _propTypes.string.isRequired,
    provider: (0, _propTypes.shape)({
      provider_pma_id: _propTypes.number.isRequired
    }).isRequired,
    location: {
      location_pma_id: _propTypes.number.isRequired,
      name: _propTypes.string.isRequired,
      address: (0, _propTypes.shape)({
        street1: _propTypes.string.isRequired,
        street2: _propTypes.string.isRequired,
        city: _propTypes.string.isRequired,
        state: _propTypes.string.isRequired,
        zip: _propTypes.string.isRequired,
        country: _propTypes.string.isRequired
      }).isRequired
    }
  }),
  /**
   * The id of the appointment we are canceling
   * Either this or the appointment object are required for this widget to initialize properly.
   * If both are provided, will default to using appointment object
   */
  appointmentId: _propTypes.number,
  /**
   * Callback that takes a providerId, patientRelationship, and patientPurpose and returns a deeplinked directbook URL for rescheduling an appointment
   * @callback createRescheduleLink
   * @param {number} providerId
   * @param {string} patientRelationship
   * @param {string} patientPurpose
   */
  createRescheduleLink: _propTypes.func.isRequired,
  /**
   * Callback triggered for tracking
   * @callback track
   * @param {string} eventName
   * @param {object} eventData
   */
  track: _propTypes.func.isRequired,
  /**
   * URL link for the `Search Providers` button.
   */
  searchProvidersLink: _propTypes.string.isRequired,
  /**
   * An object containing the appointment and provider callbacks needed for the API requests.
   *
   * If the `getProvider` callback isn't included, machine will skip getting the provider and
   * won't display the sidebar or provider's name in headings.
   *
   * `getAppointment` isn't required for the case of `appointment` being passed in as a prop, but
   * this will causes errors if the widget is initialized without the `appointment` prop.
   *
   * Please check the readme for information on how to construct the callbacks.
   */
  services: (0, _propTypes.shape)({
    cancelAppointment: _propTypes.func.isRequired,
    getAppointment: _propTypes.func,
    getProvider: _propTypes.func
  }).isRequired
};
AppointmentCancelWidget.defaultProps = {
  appointment: undefined,
  appointmentId: undefined
};
AppointmentCancelWidget.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppointmentCancelWidget",
  "props": {
    "appointment": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "An object representing the appointment we wish to cancel\nEither this or the appointmentId string are required for this widget to initialize properly.\nIf both are provided, will default to using appointment object",
      "type": {
        "name": "shape",
        "value": {
          "appointment_ehr_id": {
            "name": "string",
            "required": true
          },
          "start_datetime": {
            "name": "string",
            "required": true
          },
          "patient_relationship": {
            "name": "string",
            "required": true
          },
          "status": {
            "name": "string",
            "required": true
          },
          "purpose_name": {
            "name": "string",
            "required": true
          },
          "provider": {
            "name": "shape",
            "value": {
              "provider_pma_id": {
                "name": "number",
                "required": true
              }
            },
            "required": true
          },
          "location": {
            "name": "custom",
            "raw": "{\n  location_pma_id: number.isRequired,\n  name: string.isRequired,\n  address: shape({\n    street1: string.isRequired,\n    street2: string.isRequired,\n    city: string.isRequired,\n    state: string.isRequired,\n    zip: string.isRequired,\n    country: string.isRequired\n  }).isRequired\n}",
            "required": false
          }
        }
      },
      "required": false
    },
    "appointmentId": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The id of the appointment we are canceling\nEither this or the appointment object are required for this widget to initialize properly.\nIf both are provided, will default to using appointment object",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "createRescheduleLink": {
      "description": "Callback that takes a providerId, patientRelationship, and patientPurpose and returns a deeplinked directbook URL for rescheduling an appointment\n@callback createRescheduleLink\n@param {number} providerId\n@param {string} patientRelationship\n@param {string} patientPurpose",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "track": {
      "description": "Callback triggered for tracking\n@callback track\n@param {string} eventName\n@param {object} eventData",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "searchProvidersLink": {
      "description": "URL link for the `Search Providers` button.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "services": {
      "description": "An object containing the appointment and provider callbacks needed for the API requests.\n\nIf the `getProvider` callback isn't included, machine will skip getting the provider and\nwon't display the sidebar or provider's name in headings.\n\n`getAppointment` isn't required for the case of `appointment` being passed in as a prop, but\nthis will causes errors if the widget is initialized without the `appointment` prop.\n\nPlease check the readme for information on how to construct the callbacks.",
      "type": {
        "name": "shape",
        "value": {
          "cancelAppointment": {
            "name": "func",
            "required": true
          },
          "getAppointment": {
            "name": "func",
            "required": false
          },
          "getProvider": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": true
    }
  }
};